export const googleAnalyzeEventList = {
  add: 'add',
  minus: 'minus',
  viewItem: 'viewItem',
  login: 'login',
  signup: 'signup',
  logout: 'logout',
  creditcardBind: 'creditcardBind',
  beginCheckout: 'beginCheckout',
  purchase: 'purchase',
  screenView: 'screenView',
  historyOrders: 'historyOrders',
  pickupChoose: 'pickupChoose',
  changeStore: 'changeStore',
} as const;

export type GoogleAnalyzeEventType = (typeof googleAnalyzeEventList)[keyof typeof googleAnalyzeEventList];

export const googleAnalyzeEvent = new Map([

  // ===== 菜品相关 =====

  // 添加购物车
  [googleAnalyzeEventList.add, 'add_to_cart'],
  // 移出购物车
  [googleAnalyzeEventList.minus, 'remove_from_cart'],
  // 查看菜品详情
  [googleAnalyzeEventList.viewItem, 'view_item'],

  // ==== 登录相关 =====

  // 登录
  ['login', 'login'],
  // 注册
  ['signup', 'sign_up'],
  // 退出登录
  ['logout', 'logout'],

  // ==== 支付相关 =====

  // 绑定信用卡
  ['creditcardBind', 'creditcard_bind'],
  // 创建订单
  ['beginCheckout', 'begin_checkout'],
  // 支付成功
  ['purchase', 'purchase'],

  // ===== 用户行为相关 =====

  // 查看页面
  ['screenView', 'screen_view'],
  // 查看历史订单
  ['historyOrders', 'history_orders'],
  // 选择取餐时间
  ['pickupChoose', 'pickup_choose'],
  // 选择店铺
  ['changeStore', 'change_store'],

])